// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fullWidth_o8a1y {
    width : 100%;
  }
  .fullWidth_o8a1y > * {
    width : 100%;
  }
  /* .fixEditorHeight > div:first-child > div:first-child > div:nth-child(2) > div:first-child {
    min-height: 50vh;
  } */`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/dataViewers/actions/export/ExportSettingsEditor.css"],"names":[],"mappings":"AAAA;IACI,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;;KAEG","sourcesContent":[".fullWidth {\n    width : 100%;\n  }\n  .fullWidth > * {\n    width : 100%;\n  }\n  /* .fixEditorHeight > div:first-child > div:first-child > div:nth-child(2) > div:first-child {\n    min-height: 50vh;\n  } */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullWidth": `fullWidth_o8a1y`
};
export default ___CSS_LOADER_EXPORT___;
